'use strict';
/**
 * @deprecated since version 3.5.0.
 */

module.exports = {
  LTS_2015: '7.10',
  LTS_2016: '8.10',
  LTS_2017: '9.10'
};